import { Box } from "@mui/material";

const DotSeparator = ({ color = "#8D8D8D" }) => (
  <Box>
    <p style={{ color: color, margin: '0px', fontSize: '16px' }}>&bull;</p>
  </Box>
);

export default DotSeparator;
